import { Injectable } from '@angular/core';

import { RepositoryService } from '../services/http/repository.service';
import { SessionStorageService } from '../state-manager/session-storage/session-storage.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Roles } from './role-settings.model';

@Injectable()
export class RoleService {

  constructor(private sessionStorage: SessionStorageService, private repository: RepositoryService) { }

  public getRole() {
    let roleList: Roles[] = [];
    const userDetail = this.sessionStorage.getItem('user');
    if (userDetail && userDetail.roles) {
        if(userDetail['roles'].some(r => r.name === 'Admin'))
          roleList.push(Roles.Admin);
        if(userDetail['roles'].some(r => r.name === 'Moderator'))
          roleList.push(Roles.Moderator);
        if(userDetail['roles'].some(r => r.name === 'SuperAdmin'))
          roleList.push(Roles.SuperAdmin);
        if(userDetail['roles'].some(r => r.name === 'CaseyTA'))
          roleList.push(Roles.CaseyTA);
        if(userDetail['roles'].some(r => r.name === 'State'))
          roleList.push(Roles.State);
        if(userDetail['roles'].some(r => r.name === 'QuantDataViewer'))
          roleList.push(Roles.QuantDataViewer);
        if(userDetail['roles'].some(r => r.name === 'QuantDataOwner'))
          roleList.push(Roles.QuantDataOwner);
        if(userDetail['roles'].some(r => r.name === 'SurveyReportViewer'))
          roleList.push(Roles.SurveyReportViewer);
    }
    roleList.push(Roles.User);
    return roleList;
  }

  public isViewAsAdmin(roles: Array<Roles>) {
    const isView = this.sessionStorage.getItem('viewasAdmin') === 'true';
    if (isView && (roles.some(r => r === Roles.Admin || r === Roles.SuperAdmin))) {
      return true;
    }
    return false;
  }

  public getUserDetail() {
    return new Observable((observer) => {
      this.repository.get(environment.apiBaseURL, 'api/User')
      .subscribe(data => {
        this.sessionStorage.setItem('user', data);
        this.sessionStorage.setItem('viewuser', data);
        observer.next(data);
        observer.complete();
      }, (error) => { observer.error(error); });
    });
  }

  checkUserAccess(): Observable<any>{
    return this.repository.get(environment.apiBaseURL, 'api/User/isAccess');
  }
}
